/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyplayers2Inputs */

const en_dropdailyplayers2 = /** @type {(inputs: Dropdailyplayers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Players`)
};

const de_dropdailyplayers2 = /** @type {(inputs: Dropdailyplayers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmende`)
};

/**
* | output |
* | --- |
* | "Players" |
*
* @param {Dropdailyplayers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyplayers2 = /** @type {((inputs?: Dropdailyplayers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyplayers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyplayers2(inputs)
	return de_dropdailyplayers2(inputs)
});
export { dropdailyplayers2 as "dropDailyPlayers" }